import {
  SingleProviderConfig,
  ShopType,
  CheckoutType,
  CrossSellType,
} from 'types';
import { asyncEligible, getDefaultCrossSellAction } from 'config';
import {
  Comcast,
  Cox,
  Mediacom,
  Spectrum,
  Optimum,
  Wave,
  Grande,
  RCN,
  WOW,
  TDS,
  BuckeyeBroadband,
  ATT,
  Brightspeed,
  BrightspeedV2,
  CenturyLink,
  QuantumFiber,
  Frontier,
  Windstream,
  CincinnatiBell,
  Verizon,
} from 'config/providers';
import { CoxTheme } from 'config/themes';

export const CoxAuthorizedOffers: SingleProviderConfig = {
  name: 'CoxAuthorizedOffers',
  micrositeCode: 'cox_authorized',
  mainProvider: Cox,
  shopType: ShopType.SINGLE_PROVIDER,
  domain: 'coxauthorizedoffers.com',
  homepage: 'https://coxauthorizedoffers.com',
  title: 'Cox Authorized Dealer',
  fallbackPhoneNumber: '855-731-6095',
  fallbackLeadModePhoneNumber: '800-972-1372',
  defaultCheckoutType: CheckoutType.LEAD_MODE,
  defaultTheme: CoxTheme,
  needsDcSession: false,
  source: 'Cox',
  noOffersRetry: 2,
  movingAppBuyflowUrls: {
    development: 'http://localhost:3000/guest/tvi/buy',
    staging: 'https://staging-cart.coxauthorizedoffers.com/guest/tvi/buy',
    qa: 'https://staging-cart.coxauthorizedoffers.com/guest/tvi/buy',
    production: 'https://cart.coxauthorizedoffers.com/guest/tvi/buy',
  },
  getCrossSellAction: getDefaultCrossSellAction,
  getCheckoutType: asyncEligible,
  crossSellProviders: [
    Comcast,
    Spectrum,
    Mediacom,
    Optimum,
    Wave,
    Grande,
    RCN,
    WOW,
    TDS,
    BuckeyeBroadband,
  ],
  updaterCrossSellActive: true,
  updaterCrossSellProviders: [
    ATT,
    Brightspeed,
    BrightspeedV2,
    CenturyLink,
    QuantumFiber,
    Frontier,
    Windstream,
    CincinnatiBell,
    Verizon,
  ],
};
